import React, { useEffect } from "react";
import { Table, message, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useFiltrationModel } from "../filtrationModel";
import { IFiltrationDetails, filtrationService, IFiltrationSeachFields } from "../filtrationService";
import { YhBut } from "@/components/YhButton";
import { useNavModel } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { SorterResult, TablePaginationConfig } from "antd/es/table/interface";



export function DataTable() {
    const {
        dataSource, pgCfg, searchParam,
        loadData, setFiltrationOne, setSelectedRowKeys, selectedRowKeys
    } = useFiltrationModel();
    const { addNav } = useNavModel(() => []);

    const transfer = (id: string) => {
        filtrationService.shift(id).then(res => {
            res && addNav("3-1");
            message.success("转移成功");
        })
    }

    const columns: ColumnsType<IFiltrationDetails> = [
        {
            title: '序号',
            width: 100,
            align: "center",
            render: (t, r, i) => i + 1
        },
        {
            title: '标题',
            align: "left",
            dataIndex: 'title',
            width: 310,
            render: (text, recrod) => <Tooltip placement="topLeft" title={text} arrowPointAtCenter>
                <p
                    className="ellipsis"
                    style={{ color: "#00f" }}
                    onClick={() => {
                        setFiltrationOne([recrod]);
                        addNav("2-1");
                    }}
                >{text}</p>
            </Tooltip>
        },
        {
            title: '来源',
            align: "center",
            dataIndex: 'sourceFrom',
        },
        {
            title: '地区',
            align: "center",
            dataIndex: 'region',
        },
        {
            title: '发布日期',
            align: "center",
            dataIndex: 'pubTime',
            sorter: {
                multiple: 2
            },
        },
        {
            title: '截止日期',
            align: "center",
            dataIndex: 'bidEndTime',
            sorter: {
                multiple: 1
            },
        },
        {
            title: '过滤状态',
            align: "center",
            dataIndex: 'filterStatus',
        },
        {
            title: '采集状态',
            align: "center",
            dataIndex: 'gatherStatus',
        },
        {
            title: '采集日期',
            align: "center",
            dataIndex: 'createTime',
        },
        {
            title: '操作',
            width: 100,
            align: "center",
            fixed: "right",
            className: "td-wrap",
            render: (text, record) => <YhBut
                type="restore"
                txt="转移"
                click={() => {
                    globalPrompt("modal", {
                        title: "确认转移",
                        text: "",
                        onOk: () => transfer(record.id),
                    })
                }}
            />
        },
    ];

    useEffect(() => {
        loadData();
    }, [])

    //点击行选高亮
    const onRow = (record: IFiltrationDetails) => {
        let findObj = selectedRowKeys.find(item => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter(item => item.id !== record.id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            setSelectedRowKeys(origin => [...origin, record]);
        }
    };

    /**
     * 表格多重表头排序
     * 1.排序  ascend 向上  descend 向下
     */
    function onChange(pagination: TablePaginationConfig, filters: any, sorter: SorterResult<IFiltrationDetails> | SorterResult<any>[], extra: any) {
        // console.log(pagination)
        let obj: IFiltrationSeachFields = {};
        //多个搜索
        if (Array.isArray(sorter)) {
            sorter.forEach(item => {
                let { field, order, ...props } = item;
                if (order === "descend") {
                    obj[`${field ?? ""}Desc`] = 1
                } else if (order === "ascend") {
                    obj[`${field ?? ""}`] = 1
                }
            })
        } else {
            let { field, order, ...props } = sorter;
            if (order === "descend") {
                obj[`${field ?? ""}Desc`] = 1
            } else if (order === "ascend") {
                obj[`${field ?? ""}`] = 1
            }
        }
        loadData({ pageNum: pagination.current, pageSize: pagination.pageSize }, { ...searchParam, ...obj })
    }

    return (
        <Table
            rowKey={record => record.id}
            rowSelection={{
                //全部选中时 (存row[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                        : setSelectedRowKeys((origin) => {
                            let changeRowId = changeRows.map(item => item.id);
                            return origin.filter(item => changeRowId.indexOf(item.id) < 0)
                        });
                },
                onSelect: (record, selected, selectedRows) => onRow(record),
                selectedRowKeys: selectedRowKeys.map(item => item.id)
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    // loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record]);
                }
            })}
            onChange={onChange}
            scroll={{ x: 'max-content', }}
        />
    )
}
